module.exports = __webpack_public_path__ + "img/singleLineTextEle.beb44c7d.svg";